import React from 'react';
import FooterItem from './footerItem';
import './index.scss';

const Footer = () => (
    <div className="footer">
        <div className="footer-wrapper row">
            <FooterItem itemName="first_box"/>
            <FooterItem itemName="second_box"/>
            <FooterItem itemName="third_box"/>
        </div>
    </div>
);

export default Footer;